var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn/edit@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9844265,6.61908922 C16.5193342,6.61908922 16.9529627,7.05271765 16.9529627,7.58762542 C16.9529627,8.09106803 16.5688489,8.50479607 16.077703,8.55172794 L15.9844265,8.55616163 L6.99745875,8.55616163 C6.89410522,8.55616163 6.80802074,8.62937215 6.78811452,8.72711961 L6.7837776,8.77037173 L6.7837776,21.8969515 C6.7837776,22.0002663 6.85695418,22.0863799 6.9543685,22.106294 L6.99745875,22.1106327 L20.1240386,22.1106327 C20.2271348,22.1106327 20.3134123,22.0372423 20.3333707,21.9399616 L20.3377197,21.8969515 L20.3377197,14.6301497 C20.3377197,14.095242 20.7713481,13.6616135 21.3062559,13.6616135 C21.8096985,13.6616135 22.2234266,14.0457273 22.2703584,14.5368732 L22.2747921,14.6301497 L22.2747921,21.8969515 C22.2747921,23.0450034 21.3748159,23.983248 20.2420268,24.0445221 L20.1240386,24.0477051 L6.99745875,24.0477051 C5.84900735,24.0477051 4.91113561,23.147837 4.84988689,22.0149506 L4.8467052,21.8969515 L4.8467052,8.77037173 C4.8467052,7.62184043 5.74615619,6.68354899 6.87941802,6.62227237 L6.99745875,6.61908922 L15.9844265,6.61908922 Z M23.7096218,5.14776154 L24.6850172,6.08771691 C24.8950129,6.28977822 24.9013604,6.62460756 24.6987701,6.83460322 L13.2257077,18.7435256 C13.1590592,18.8128189 13.0738973,18.8625408 12.980801,18.8874017 L11.7176533,19.2222311 C11.33416,19.3237907 10.9797592,18.9826139 11.067037,18.5954178 L11.3547893,17.3206331 C11.3759475,17.2264789 11.4224957,17.140259 11.4896731,17.0704368 L22.9627355,5.16151441 C23.1653258,4.95151875 23.4996262,4.94517128 23.7096218,5.14776154 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn/edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)",
    fill: "#47D5CD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5c1989d0ddc07fdd76e8851c5c592750.svg";
export { ForwardRef as ReactComponent };